import BaseModelAPI from '../BaseModelAPI';

export default class PartPurchaseQualityControlList extends BaseModelAPI {

	static entity = 'partpurchasequalitycontrollist'
	static entityName = 'partpurchasequalitycontrol';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
